package org.junqueira.portfolio.data

import org.jetbrains.compose.resources.DrawableResource

data class Project(
    val name: String = "",
    val namePt: String = "",
    val description: String = "",
    val descriptionPt: String = "",
    val image: DrawableResource,
    val tags: List<String>,
    val openGithub: () -> Unit,
    val demoUrl: String,
    val isLast: Boolean = false,
)